import React, { useEffect } from 'react';
import { useKakaoLoginMutation } from '@/services/externalService';
import useLoginStore from '@/stores/common/login';
import { useConnectKakaoSocialMutation } from '@/services/userService';
import useUserStore from '@/stores/user/user';

export default function KakaoLoginRedirect() {
    const ls = useLoginStore();
    const us = useUserStore();
    const KakaoLoginMutation = useKakaoLoginMutation(ls, us);
    const ConnectKakaoLoginMutation = useConnectKakaoSocialMutation();

    useEffect(() => {
        let code = new URL(window.location.href).searchParams.get('code');
        const api = localStorage.getItem('api');
        switch (api) {
            case 'kakaoLogin':
                KakaoLoginMutation.mutate(code);
                break;
            case 'connectKakaoSocial':
                ConnectKakaoLoginMutation.mutate({ user_id: us.user.id, code: code });
                break;
            default:
                return;
        }
    }, []);

    return;
}
